import React from 'react';
import './InfoJobs.scss';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';

interface IProps {
  content: Julius.Website.JobsPageViewModel;
}

const InfoJobs: React.SFC<IProps> = ({
  content,
}) => {

  if (!content) {
    return null;
  }

  const { title, text } = content;

  return (
    <WrapperLayout style='info-jobs'>
      <div className='jobs-title'>{ title }</div>
      <div dangerouslySetInnerHTML={ { __html: text } } />
    </WrapperLayout>
  );
};

export default InfoJobs;


// WEBPACK FOOTER //
// ./src/components/InfoJobs/InfoJobs.tsx